import React, { useState } from "react";
import { toast } from "sonner";
import { MessageCircle, Instagram, Mail, Clock } from "lucide-react";
import { BRAND, waLink } from "../config";
import { sendContact } from "../lib/api";
import { WhatsAppIcon } from "../components/WhatsAppButton";

const FAQ = [
  { q: "Quels sont les délais de livraison ?", a: "En Guadeloupe, les articles en stock sont livrés sous 2 à 5 jours." },
  { q: "Comment passer commande ?", a: "Directement sur le site via le panier, ou sur WhatsApp pour un accompagnement personnalisé." },
  { q: "Livrez-vous aux îles ?", a: "Oui, nous livrons à Marie-Galante, Les Saintes et La Désirade (délais légèrement plus longs)." },
  { q: "Quels moyens de paiement ?", a: "Paiement à la livraison et via WhatsApp. Le paiement CB/PayPal arrive bientôt." },
  { q: "Puis-je retourner un article ?", a: "Oui, sous 7 jours (hors lingerie et maillots pour raisons d'hygiène)." },
];

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sent, setSent] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    try { await sendContact(form); setSent(true); toast.success("Message envoyé ! Nous vous répondrons vite."); setForm({ name: "", email: "", message: "" }); }
    catch { toast.error("Une erreur est survenue"); }
  };
  return (
    <div data-testid="contact-page">
      <div className="bg-noir text-center py-16 px-6 grain relative">
        <h1 className="font-display text-4xl md:text-6xl text-white relative">Contactez-nous</h1>
        <p className="font-serif-el italic text-dore text-lg mt-2 relative">Nous sommes à votre écoute</p>
      </div>

      <div className="max-w-6xl mx-auto px-6 py-14 grid md:grid-cols-3 gap-6">
        <a href={waLink()} target="_blank" rel="noreferrer" className="border border-dore/20 bg-white p-8 text-center hover:border-dore transition-colors" data-testid="contact-whatsapp">
          <div className="w-14 h-14 rounded-full bg-whatsapp/10 flex items-center justify-center mx-auto mb-4"><MessageCircle size={26} className="text-whatsapp" /></div>
          <h3 className="font-display text-xl text-encre mb-1">WhatsApp</h3>
          <p className="text-sm text-ardoise mb-4">Le plus rapide pour commander</p>
          <span className="inline-flex items-center gap-2 bg-whatsapp text-white px-5 py-2.5 text-xs uppercase tracking-widest"><WhatsAppIcon size={14} /> Écrire</span>
        </a>
        <a href={BRAND.instagram} target="_blank" rel="noreferrer" className="border border-dore/20 bg-white p-8 text-center hover:border-dore transition-colors">
          <div className="w-14 h-14 rounded-full bg-rose/40 flex items-center justify-center mx-auto mb-4"><Instagram size={26} className="text-encre" /></div>
          <h3 className="font-display text-xl text-encre mb-1">Instagram</h3>
          <p className="text-sm text-ardoise mb-4">{BRAND.instagramHandle}</p>
          <span className="inline-block bg-rose text-encre px-5 py-2.5 text-xs uppercase tracking-widest">Nous écrire</span>
        </a>
        <div className="border border-dore/20 bg-white p-8 text-center">
          <div className="w-14 h-14 rounded-full bg-dore/10 flex items-center justify-center mx-auto mb-4"><Clock size={26} className="text-dore" /></div>
          <h3 className="font-display text-xl text-encre mb-1">Disponibilité</h3>
          <p className="text-sm text-ardoise">Lun - Sam<br />9h - 19h (heure Guadeloupe)</p>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-6 pb-16 grid md:grid-cols-2 gap-12">
        <div>
          <h2 className="font-display text-2xl text-encre mb-5">Envoyez-nous un message</h2>
          <form onSubmit={submit} className="space-y-4" data-testid="contact-form">
            <input required placeholder="Votre nom" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="w-full border border-dore/30 px-4 py-3 text-sm outline-none focus:border-dore" data-testid="contact-name" />
            <input required type="email" placeholder="Votre email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="w-full border border-dore/30 px-4 py-3 text-sm outline-none focus:border-dore" data-testid="contact-email" />
            <textarea required rows={5} placeholder="Votre message" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="w-full border border-dore/30 px-4 py-3 text-sm outline-none focus:border-dore" data-testid="contact-message" />
            <button className="bg-noir text-white px-8 py-3.5 text-xs uppercase tracking-widest font-semibold hover:bg-ardoise transition-colors" data-testid="contact-submit">{sent ? "Message envoyé ✓" : "Envoyer"}</button>
          </form>
        </div>
        <div>
          <h2 className="font-display text-2xl text-encre mb-5">Questions fréquentes</h2>
          <div className="space-y-4">
            {FAQ.map((f, i) => (
              <div key={i} className="border-b border-dore/15 pb-4">
                <p className="text-encre font-medium text-sm">{f.q}</p>
                <p className="text-ardoise text-sm mt-1">{f.a}</p>
              </div>
            ))}
          </div>
          <a href={`mailto:${BRAND.email}`} className="inline-flex items-center gap-2 mt-6 text-dore text-sm hover:underline"><Mail size={16} /> {BRAND.email}</a>
        </div>
      </div>
    </div>
  );
}
